import React, { useEffect, useRef, useState } from 'react';
import { Tour } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { NavbarButton } from './NavbarButton';
import { iconButtonStyle } from '../../utils/styles';
import { useStore } from '../../store/store';
import { verifyTour } from '../../requests/tours';

// « ? » de la barre du haut : ouvre l'aide de l'éditeur dans un nouvel onglet, sur le mode affiché (modèle, ou
// proposition pour une opportunité/une offre). Aucun identifiant de document n'est transmis : son métier seul (ou
// `offer`), pour que l'aide ne montre que ses tableaux (cf. help/helpWork).
// Visite d'une étape montrée une seule fois par utilisateur, comme le bouton d'aide de web (help_tour).
const TOUR_NAME = 'editor_help_tour';

export const HelpButton = () => {
  const { t } = useTranslation();
  const isTemplate = useStore(({ currentDocument }) => currentDocument?.type === 'template');
  const work = useStore(({ currentDocument, currentTemplate, currentProposal }) => {
    if (currentDocument?.type === 'template') {
      return currentTemplate?.templatable === 'offer' ? 'offer' : currentTemplate?.work;
    }
    return currentDocument?.type === 'offer' ? 'offer' : currentProposal?.work;
  });
  const [runTour, setRunTour] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    // Laisse l'éditeur finir de se charger avant de poser la bulle.
    const timer = setTimeout(() => {
      verifyTour(TOUR_NAME).then((show) => !cancelled && setRunTour(show));
    }, 1500);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  const openHelp = () => {
    const query = work ? `?work=${encodeURIComponent(work)}` : '';
    window.open(`/help/${isTemplate ? 'template' : 'proposal'}${query}`, '_blank', 'noopener');
  };

  return (
    <>
      <span ref={targetRef} style={{ display: 'inline-flex' }}>
        <NavbarButton
          tooltipContent={t('help.button')}
          onClick={openHelp}
          icon={
            <FontAwesomeIcon
              icon={icon({ name: 'circle-question', family: 'duotone', style: 'solid' })}
              style={iconButtonStyle()}
            />
          }
        />
      </span>
      <Tour
        open={runTour}
        onClose={() => setRunTour(false)}
        steps={[
          {
            target: () => targetRef.current,
            title: t('help.tour.title'),
            description: t('help.tour.content'),
            placement: 'bottomRight',
            nextButtonProps: { children: 'OK' },
          },
        ]}
        // La navbar est fixed à zIndex 1100 (Navbar.jsx).
        zIndex={1300}
      />
    </>
  );
};
